module.exports = __webpack_public_path__ + "img/question.6144c158.svg";